import React from "react";
import { useParams } from "wouter";
import { Alert } from "../../../../components/src/Alert";
import { useQueryState } from "../../../../components/src/use-query-state";

import { DateForm } from "../../../../components/src/dateForm";
import { TradingManager } from ".";
import { PmSelectPrompt } from "./PmSelectPrompt";

export interface Props {
    lookThrough: boolean;
    tradingView: boolean;
}

const check_today_date = (endDate: string) => {
    const today = new Date().toISOString().slice(0, 10);
    if (endDate === today) {
        return true;
    } else {
        return false;
    }
};

export const TradingManagerView = (props: Props): React.ReactElement => {
    const [endDate] = useQueryState("endDate", new Date().toISOString().slice(0, 10));

    const { id } = useParams<{ id: string }>();

    if (typeof id === "undefined" || id === "all") {
        return <PmSelectPrompt message="Select a client" />;
    }

    return (
        <div>
            <div className="flex">
                <DateForm defaultDateString={endDate} dateName={"endDate"}></DateForm>
                {!check_today_date(endDate) ? (
                    <Alert className="ml-2" variant={"danger"}>
                        Historical or future date selected
                    </Alert>
                ) : null}
            </div>
            <br />
            <div className="flex flex-wrap -mx-2">
                <div className={"w-full px-2"}>
                    <TradingManager
                        clientIds={[id]}
                        endDate={endDate as string}
                        lookThrough={props.lookThrough}
                        tradingView={props.tradingView}
                    />
                </div>
            </div>
        </div>
    );
};
